// 🌎 IDIOMAS (22/10/2026): reconhece quando um curso ou uma skill é de idioma, para a vitrine /capacitacao separar o
// bloco "Idiomas" e o popup "Melhorar minhas skills" mostrar as escolas parceiras daquele idioma.
// Trabalha com a CHAVE do idioma ("ingles", "espanhol"…). Casa por palavra inteira, sem acento e sem caixa:
// "Inglês avançado", "English", "Inglês com foco em conversação" → "ingles".
const IDIOMAS = {
  ingles: ["ingles", "english"],
  espanhol: ["espanhol", "spanish", "espanol", "castelhano"],
  frances: ["frances", "french", "francais"],
  alemao: ["alemao", "german", "deutsch"],
  italiano: ["italiano", "italian"],
  mandarim: ["mandarim", "chines", "mandarin", "chinese"],
  japones: ["japones", "japanese"],
  libras: ["libras"],
  portugues: ["portugues para estrangeiros"],
};

const normalizar = (s) => (s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

// Todos os idiomas citados (um curso "Inglês e espanhol" é dos dois). Vazio = não é idioma.
export function idiomasDe(texto) {
  const t = ` ${normalizar(texto).replace(/[^a-z0-9]+/g, " ").trim()} `;
  return Object.entries(IDIOMAS).filter(([, nomes]) => nomes.some((n) => t.includes(` ${n} `))).map(([chave]) => chave);
}

// A escola ensina o idioma desta skill? (skill "Inglês avançado" × curso "Inglês com foco em conversação" → sim)
export const mesmoIdioma = (skill, curso) => { const c = idiomasDe(curso); return idiomasDe(skill).some((k) => c.includes(k)); };
